import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Container, Card } from "@mui/material";
import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";

const responsive = {
	desktop: {
	  breakpoint: { max: 3000, min: 1024 },
	  items: 5,
	  slidesToSlide: 2 // optional, default to 1.
	},
	tablet: {
	  breakpoint: { max: 1024, min: 464 },
	  items: 2,
	  slidesToSlide: 2 // optional, default to 1.
	},
	mobile: {
	  breakpoint: { max: 464, min: 0 },
	  items: 1,
	  slidesToSlide: 1 // optional, default to 1.
	}
  };

const Clients = ({data, parseContent}) => {

  return (
		<Card id="Clients" sx={{borderRadius:0}}>
			<Container   py={{xs:2, lg:5}} sx={{mt:2}} className="container">
				<div className="section-title">
					<h2>{data ? data.title : "...loading"}</h2>
				</div>
				<Carousel
			additionalTransfrom={0}
			arrows={false}
						infinite
			autoPlaySpeed={2000}
			centerMode={false}
			className=""
			containerClass="container-with-dots"
			dotListClass="slick-dots"
			draggable
			focusOnSelect={false}
					autoPlay
			itemClass=""
			keyBoardControl
			minimumTouchDrag={80}
			pauseOnHover
			renderArrowsWhenDisabled={false}
			renderButtonGroupOutside={false}
			renderDotsOutside={false}
			responsive={responsive}
			showDots
			rewind={false}
			rewindWithAnimation={false}
			rtl={false}
			sliderClass=""
			slidesToSlide={2}
			swipeable
			>																					
					{data.cards ? data.cards.map((item,i)=>(
							<MDBox key={`${item.title}-${i}`} m={{xs:1, lg:2}}  >
								<MDBox component="img" sx={{width:"100%", maxHeight:"180px", border :.5, borderColor :  ({borders:{borderColor}})=>borderColor, objectFit:"cover"}}  src={`${process.env.REACT_APP_PUBLIC_URL}/img/clients/${item.img}`} alt={item.title} />
								<MDTypography display="block" variant="h6" sx={{color:"#23346a"}} textTransform="capitalize" textAlign="center" fontWeight="regular">
										{item.title}
								</MDTypography>
								<div className="overlay">{parseContent(item.text)}</div>
							</MDBox>
						)) : "Loading..."}
				</Carousel>
			</Container>
		</Card>
  );
};
export default Clients